import { render, staticRenderFns } from "./MarginInstructions.vue?vue&type=template&id=b750bc8e&scoped=true&"
import script from "./MarginInstructions.vue?vue&type=script&lang=js&"
export * from "./MarginInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b750bc8e",
  null
  
)

export default component.exports